import _ from 'lodash';
import {atom, selector} from 'recoil';
import {endOfWeek, startOfWeek} from 'date-fns';

export const colorDeclarations = atom({
  key: 'colorDeclarations',
  default: null,
});

export const colorDeclarationsProjectName = atom({
  key: 'colorDeclarationsProjectName',
  default: '',
});

export const colorDeclarationsFilterNumber = atom({
  key: 'colorDeclarationsFilterNumber',
  default: null,
});

export const colorDeclarationsFiltered = selector({
  key: 'colorDeclarationsFiltered',
  get: ({get}) => {
    const declarationsData = get(colorDeclarations);
    const filterNumber = get(colorDeclarationsFilterNumber);

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentDate = new Date();
    const dayOfBeginningOfWeek = startOfWeek(currentDate, {weekStartsOn: 1});
    const dayOfEndOfWeek = endOfWeek(currentDate, {weekStartsOn: 1});

    if (filterNumber == null) {
      return declarationsData;
    }
    if (filterNumber === 1) {
      return _.filter(declarationsData, (el: any) => {
        const elDate = new Date(el.created_at);
        return elDate >= dayOfBeginningOfWeek && elDate <= dayOfEndOfWeek;
      });
    }
    if (filterNumber === 2) {
      return _.filter(declarationsData, (el: any) => {
        const elDate = new Date(el.created_at);
        return elDate.getMonth() === currentMonth;
      });
    }
    if (filterNumber === 3) {
      return _.filter(declarationsData, (el: any) => {
        const elDate = new Date(el.created_at);
        return elDate.getFullYear() === currentYear;
      });
    }
  },
});
